<!--寸法検査機能で測定値を入力するためのatoms-->
<template>
  <div v-if="disabledComputed">{{ formattedValue }}</div>
  <div v-else class="text-meas-value">
    <TextFieldInput
      v-if="measFmtCd == enumMeasFmtCd.NUMBER"
      :vid="vid"
      :label="label"
      v-model="model"
      rules="inspCharacVal"
      :disabled="disabledComputed"
      :required="required"
      right
      @change="onChange"
    />
    <SelectSingleInput
      v-else-if="measFmtCd == enumMeasFmtCd.OK_NG"
      :vid="vid"
      v-model="model"
      :items="dimJudgeItems"
      itemText="name"
      itemValue="value"
      :label="label"
      :disabled="disabledComputed"
      :required="required"
      @change="onChange"
    />
  </div>
</template>

<script>
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { MeasFmtCd, DimJudgeCd } from '@/enum'

export default {
  name: 'MeasValueInput',

  components: { TextFieldInput, TextFieldRef, SelectSingleInput },

  props: {
    value: {
      type: [String, Number],
      default: '',
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    measFmtCd: {
      type: String,
      required: true,
    },
    vid: {
      type: String,
      required: false,
      default: '',
    },
  },

  computed: {
    enumMeasFmtCd: () => MeasFmtCd,
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    dimJudgeItems: {
      get() {
        // プルダウン選択肢をenumから生成
        return Object.values(DimJudgeCd).map((item) => {
          return { name: this.$t(`DimJudgeCd.${item}`), value: item }
        })
      },
    },
    disabledComputed: {
      get() {
        return this.disabled
      },
    },
    formattedValue: {
      get() {
        let value = this.model
        if (value && this.measFmtCd == MeasFmtCd.OK_NG) {
          value = this.$t(`DimJudgeCd.${value}`)
        }
        return value
      },
    },
  },

  methods: {
    onChange() {
      this.$emit('change')
    },
  },
}
</script>

<style scoped>
.text-meas-value {
  min-width: 150px !important;
}
</style>
